import { render } from "./PanelWorkout.vue?vue&type=template&id=29b717dc&scoped=true"
import script from "./PanelWorkout.vue?vue&type=script&lang=js"
export * from "./PanelWorkout.vue?vue&type=script&lang=js"

import "./PanelWorkout.vue?vue&type=style&index=0&id=29b717dc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b717dc"]])

export default __exports__